function sanitizeDari(s: string): string {
    // TODO: IMPLEMENT
    return s;
}

export default sanitizeDari;